"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSettingEditForm = buildSettingEditForm;
function buildSettingEditForm(response) {
    let form;
    let mapData;
    let mapResult;
    switch (response.data.type) {
        case 'boolean':
            form = {
                type: 'form',
                children: [{ type: 'form.checkbox', key: 'value', label: response.data.label ?? 'Boolean Value' }],
            };
            mapData = (value) => ({ value: value === 'true' });
            mapResult = (data) => data.value.toString();
            break;
        case 'number':
            form = {
                type: 'form',
                children: [{ type: 'form.number', key: 'value', label: response.data.label ?? 'Number Value' }],
            };
            mapData = (value) => ({ value: parseFloat(value) });
            mapResult = (data) => (data.value ? data.value.toString() : '0');
            break;
        case 'string':
            if (response.data.values && response.data.values.length < 4) {
                form = {
                    type: 'form',
                    children: [{ type: 'form.radio', key: 'value', values: response.data.values }],
                };
            }
            else if (response.data.values && response.data.values.length >= 4) {
                form = {
                    type: 'form',
                    children: [
                        { type: 'form.select', key: 'value', label: response.data.label ?? 'Setting Value', values: response.data.values },
                    ],
                };
            }
            else {
                form = {
                    type: 'form',
                    children: [{ type: 'form.text', key: 'value', label: response.data.label ?? 'String Value', multiline: true, rows: 5 }],
                };
            }
            mapData = (value) => ({ value: value });
            mapResult = (data) => data.value;
            break;
        case 'json':
            if (response.data.form) {
                form = response.data.form;
                mapData = (value) => JSON.parse(value);
                mapResult = (data) => JSON.stringify(data, undefined, '  ');
            }
            else {
                form = {
                    type: 'form',
                    children: [
                        {
                            type: 'form.text',
                            key: 'value',
                            label: response.data.label ?? 'JSON',
                            multiline: true,
                            rows: 15,
                            validate: {
                                required: true,
                                custom: (value) => {
                                    if (value) {
                                        try {
                                            JSON.parse(value);
                                        }
                                        catch (e) {
                                            return e.message;
                                        }
                                    }
                                },
                            },
                        },
                    ],
                };
                mapData = (value) => ({ value: value });
                mapResult = (data) => data.value;
            }
            break;
        case 'color':
            form = {
                type: 'form',
                children: [{ type: 'form.text', key: 'value', label: response.data.label ?? 'Color' }],
            };
            mapData = (value) => ({ value: value });
            mapResult = (data) => data.value;
            break;
        case 'image':
            form = {
                type: 'form',
                children: [{ type: 'form.image', key: 'value', label: response.data.label ?? 'Data URL' }],
            };
            mapData = (value) => ({ value: value });
            mapResult = (data) => data.value;
            break;
    }
    if (response.data.readOnly) {
        form = {
            type: 'form',
            children: [
                {
                    key: 'content',
                    text: 'This setting is read-only and cannot be changed here.',
                    type: 'form.content',
                    style: {
                        alert: 'info',
                    },
                },
                ...form.children,
            ],
        };
    }
    return {
        formConfig: form,
        formData: mapData(response.data.value),
        defaultFormData: mapData(response.data.type === 'json'
            ? JSON.stringify(response.data.defaultValue, undefined, '  ')
            : response.data.defaultValue.toString()),
        mapResult,
    };
}
